/* PracticeRibbon — a calm, unmissable band above the app bar (13-08). */

.ribbon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 4px 12px;
  padding: 7px var(--shell-gutter);
  background: var(--amber-soft);
  border-bottom: 1px solid var(--amber-line);
  font-size: 12.8px;
  color: var(--charcoal);
  text-align: center;
}

.mark {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1.6px solid var(--amber);
  flex: none;
}

.title {
  font-weight: 600;
  color: var(--amber-dark);
}

.detail {
  color: var(--gray);
}

@media (max-width: 720px) {
  .detail {
    display: none;
  }
}
